import React from "react";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import { Col, Form, Modal, Row } from "react-bootstrap";
import {
  addPrescriberType,
  updatePrescriberType,
} from "../../../../actions/settings/prescriberType/admin/prescriberType";
import Util from "../../../../util/Util";
import CustomLabel from "../../../sub/CustomLabel";
import InputLength from "../../../../enums/InputLength";
import InputTextElement from "../../../sub/InputTextElement";
import MenuButton from "../../../sub/bootstrap/MenuButton";

class PrescriberTypeModalAdmin extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      disabled: false,
      modal: null,
      nameError: null,
    };

    if (this.props.prescriberType) {
      this.state = {
        name: this.props.prescriberType.name,
        disabled: false,
        modal: null,
        nameError: null,
      };
    }
  }

  close() {
    this.props.closeModal();
  }

  onChange(field, value) {
    if (field === "name") {
      if (
        this.props.prescriberType &&
        value === this.props.prescriberType.name
      ) {
        this.setState({ nameError: null });
      } else {
        const alreadyExisting = this.props.prescriberTypes.find(
          (t) => value === t.name,
        );

        if (alreadyExisting) {
          this.setState({
            nameError: (
              <FormattedMessage id="PrescriberType.Already.Existing" />
            ),
          });
        } else {
          this.setState({ nameError: null });
        }
      }
    }

    this.setState({ [field]: value });
  }

  onSubmit() {
    if (this.checkErrors()) return;

    this.setState({ disabled: true });

    var data = {
      name: this.state.name,
      client_type: this.props.clientType,
    };

    var successCallback = () => {
      this.props.closeModal();
    };

    this.props.onAddPrescriberType(data, successCallback);
  }

  onUpdate(updatedField, updatedValue) {
    if (!this.props.prescriberType || this.checkErrors()) return;

    var data = {
      _id: this.props.prescriberType._id,
      name: updatedValue,
    };

    this.props.onUpdatePrescriberType(data);
  }

  checkErrors() {
    return (
      this.state.nameError ||
      this.state.disabled ||
      Util.emptyString(this.state.name)
    );
  }

  render() {
    return (
      <Modal
        show={true}
        onHide={() => this.close()}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <FormattedMessage
              id={
                this.props.prescriberType
                  ? "Modify.Client.Type"
                  : "Add.Client.Type"
              }
            />
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form.Group as={Row} className="align-items-center">
            <CustomLabel
              label={this.props.intl.formatMessage({ id: "Client.Type" })}
              htmlFor="name"
              displayAsCol
              required
            />
            <Col md={7}>
              <InputTextElement
                className="form-control"
                type="text"
                id="name"
                autoComplete="off"
                value={this.state.name}
                maxLength={InputLength.NAME}
                onChange={(e) => this.onChange("name", e.target.value)}
                onBlur={(e) => this.onUpdate("name", this.state.name)}
              />
              <small className="text-danger">{this.state.nameError}</small>
            </Col>
          </Form.Group>
        </Modal.Body>

        {!this.props.prescriberType && (
          <Modal.Footer>
            <MenuButton variant="secondary" onClick={() => this.close()}>
              <FormattedMessage id="Cancel" />
            </MenuButton>
            <MenuButton
              onClick={() => this.onSubmit()}
              disabled={this.checkErrors()}
            >
              <FormattedMessage id="Add" />
            </MenuButton>
          </Modal.Footer>
        )}
        {this.state.modal}
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    prescriberTypes: state.prescriberTypes,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAddPrescriberType: (data, successCallback) =>
      dispatch(addPrescriberType(data, successCallback)),
    onUpdatePrescriberType: (data) => dispatch(updatePrescriberType(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(PrescriberTypeModalAdmin));
